export const TESTIMONIAL_API_ROUTES = {
  GET_TESTIMONIAL: "/admin/testimonial",
  GET_TESTIMONIAL_BY_ID: "admin/testimonial/:id",
  CREATE_TESTIMONIAL: "/admin/testimonial",
  UPDATE_TESTIMONIAL: "/admin/testimonial/:id",
  DELETE_TESTIMONIAL: "/admin/testimonial/:id",
};
